module.exports = __webpack_public_path__ + "img/21_110.7f59554c.png";